import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { composeApiURL } from "helpers/utility/axiosHelpers";
import { useLocation } from "react-router";
import { SEED_PARAMETER } from "helpers/constants/miscellaneous";

interface FlywheelStatusData {
  seed_id?: string;
  flow_id?: string;
}

export const useSeed = (datasetId?: string) => {
  const [seedId, setSeedId] = useState<string | null>(null);
  const [flowId, setFlowId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const location = useLocation();

  const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

  const fetchSeedAndStatus = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const statusUrl = composeApiURL(HOST_URL, `/flywheel/${datasetId}`);
      const res = await axios.get<FlywheelStatusData>(statusUrl);

      setFlowId(res.data.flow_id || null);

      if (res.data.seed_id) {
        setSeedId(res.data.seed_id);
        return res.data.seed_id;
      } else {
        const seedUrl = composeApiURL(HOST_URL, `/flywheel/${datasetId}/seed`);
        const putRes = await axios.put<{ id: string }>(seedUrl);
        setSeedId(putRes.data.id);
        return putRes.data.id;
      }
    } catch (e) {
      setError(e);
      return null;
    } finally {
      setLoading(false);
    }
  }, [datasetId, HOST_URL]);

  useEffect(() => {
    if (datasetId) {
      const params = new URLSearchParams(location.search);
      const seedParam = params.get(SEED_PARAMETER);
      if (!seedParam) {
        fetchSeedAndStatus();
      }
    }
  }, [datasetId, fetchSeedAndStatus, location.search]);

  const fetchSeed = useCallback(async () => {
    if (seedId) return seedId;

    setLoading(true);
    setError(null);
    try {
      const seedUrl = composeApiURL(HOST_URL, `/flywheel/${datasetId}/seed`);
      const res = await axios.put<{ id: string }>(seedUrl);
      setSeedId(res.data.id);
      return res.data.id;
    } catch (e) {
      setError(e);
      return null;
    } finally {
      setLoading(false);
    }
  }, [datasetId, seedId, HOST_URL]);

  return {
    seedId,
    flowId,
    loading,
    error,
    fetchSeedAndStatus,
    fetchSeed,
  };
};
